const BtnLoader=()=>{
    return(<>
    <div class="spinner-border" role="status">
</div>
    </>)
};

export default BtnLoader;